// 注册全局组件
import suContainer from '@/components/su-container.vue'

export default {
  install(Vue) {
    Vue.component('su-container', suContainer)
  },
}